import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ArrowSelect } from 'assets/arrow-select.svg';
import i18nContext from 'components/i18n-context';
import './OperatorsTableHeadRow.scss';

export const OPERATORS_TABLE_HEADER = [
  {
    label: 'id',
    sortBy: null
  },
  {
    label: 'login',
    sortBy: null
  },
  {
    label: 'name',
    sortBy: null
  },
  {
    label: 'email',
    sortBy: null
  },
  {
    label: 'role',
    sortBy: null
  },
  {
    label: 'status',
    sortBy: null
  },
  {
    label: 'actions',
    sortBy: null
  }
];

const OperatorsTableHeadRow = ({ handleOnSortTable, sortBy, direction }) => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {OPERATORS_TABLE_HEADER.map(
        (head) =>
          head.label && (
            <th key={head.label} className={'operators-table-head'}>
              <div className={'operators-table-head-block'}>
                <span>{i18n.getMessage(`operators.table.header.${head.label}`)}</span>
                {head.sortBy && (
                  <ArrowSelect
                    onClick={() => handleOnSortTable(head.sortBy)}
                    className={`operators-sorting-arrow-icon ${sortBy === head.sortBy && direction}`}
                  />
                )}
              </div>
            </th>
          )
      )}
    </tr>
  );
};

OperatorsTableHeadRow.propTypes = {
  handleOnSortTable: PropTypes.func,
  sortBy: PropTypes.string,
  direction: PropTypes.string
};

export default OperatorsTableHeadRow;
